import {
    IPage,
    PageTypes,
    PageFilterableField,
    PageSearchSortableField,
    PageSearchSortOrder,
    FilterKind,
} from "./pages";
import { formatMessage } from "lib/globalize-util";
import { DefaultOrder } from "./sites";

export const LOADING_ID = "loadingId";

export const getLoadingPage = (kind: PageTypes): IPage => ({
    site_id: LOADING_ID,
    page_id: "",
    kind,
    published: true,
    full_width: false,
    active: true,
    brand_id: "",
    title: formatMessage("Loading..."),
    description: "",
    body: null,
    tags: [],
    parents: [],
    created_by_user_id: "",
    last_modified_by_user_id: "",
    hero_image: null,
    tile_image: null,
    created_at: "",
    modified_at: "",
    weight: 0,
    is_category: false,
});

export const getSubcategoryFilters = (parentId: string) => ({
    filters: [
        {
            [FilterKind.And]: {
                filters: [
                    {
                        [FilterKind.Eq]: {
                            field: PageFilterableField.Parents,
                            value: parentId,
                        },
                    },
                    {
                        [FilterKind.Eq]: {
                            field: PageFilterableField.Kind,
                            value: PageTypes.Category as string,
                        },
                    },
                ],
            },
        },
    ],
    sort_by: PageSearchSortableField.SortByTitle,
    sort_order: PageSearchSortOrder.Asc,
});

export const getDefaultOrderLabel = (key: DefaultOrder) => {
    switch (key) {
        case DefaultOrder.Random:
            return formatMessage("Random");
        case DefaultOrder.Alphabetical:
            return formatMessage("A-Z");
        case DefaultOrder.ReverseAlphabetical:
            return formatMessage("Z-A");
        default:
            return "";
    }
};

export const LANDING_PAGE_DELIMITER = ":";

export const buildLandingPageId = ({
    siteId,
    pageId,
    siteSlug,
}: {
    siteId: string;
    pageId: string;
    siteSlug: string;
}) => {
    return `siteId${LANDING_PAGE_DELIMITER}${siteId}${LANDING_PAGE_DELIMITER}pageId${LANDING_PAGE_DELIMITER}${pageId}${LANDING_PAGE_DELIMITER}siteSlug${LANDING_PAGE_DELIMITER}${siteSlug}`;
};
